import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, TagDefinition, ErrorLevel, TagDefinitionVm } from '../../../models';
import { Roles, saveErrorMessage, tagDefaultState, WideError } from '../../../common/';
import { IAuthorizationService, ILoggerService } from '../../../services/';
import { IRootScope } from 'IRootScope';

class TagsTilesController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    mayAcquire: boolean;
    selectedItem: TagDefinition;

    readonly formController: angular.IFormController;
    readonly isEditMode: boolean;
    readonly tagViewModels: TagDefinitionVm[];

    static $inject = ['$rootScope', '$state', '$translate', 'authorizationService', 'loggerService'];

    constructor(
        private _$rootScope: IRootScope,
        private _$state: angular.ui.IStateService,
        private _$translate: angular.translate.ITranslateService,
        private _authorizationService: IAuthorizationService,
        private _loggerService: ILoggerService
    ) {
    }

    $onInit() {
        this.mayAcquire = this._authorizationService.isInRoles(Roles.acquisitionRoles);
    }

    select(item: TagDefinitionVm, $event) {
        const isPrevented = $event.isDefaultPrevented ? $event.isDefaultPrevented() : $event.defaultPrevented;
        if (!isPrevented) {
            if (this._$rootScope.isEditMode) {
                if (!this.formController || (!this.formController.$dirty && !this.formController.$invalid)) {
                    this.selectedItem = item;
                    if ($event.preventDefault) {
                        $event.preventDefault();
                    }
                } else {
                    const msg = this._$translate.instant(saveErrorMessage);
                    this._loggerService.logWarning(msg);
                    $event.stopPropagation();
                }
            } else {
                this._$state.go(tagDefaultState, { tagDefinitionGuid: item.guid, tag: item });
            }
        }
    }

    getClass(tag: TagDefinitionVm) {
        const result: any = {};
        if (!!tag.errors && tag.errors.length > 0) {
            if (_.some(tag.errors, (e: WideError) => e.level === ErrorLevel.Error)) {
                result['panel-danger'] = true;
            } else if (_.some(tag.errors, (e: WideError) => e.level === ErrorLevel.Warning)) {
                result['panel-warning'] = true;
            }
        } else {
            result['panel-default'] = true;
        }
        if (this.isSelected(tag)) {
            result['bordered'] = true;
        }
        return result;
    }

    getError(tag: TagDefinitionVm) {
        let result: WideError;
        if (!!tag.errors) {
            const error = _.find(tag.errors, (e: WideError) => e.level === ErrorLevel.Error);
            if (error) {
                result = error;
            } else {
                result = _.find(tag.errors, (e: WideError) => e.level === ErrorLevel.Warning);
            }
        }
        return result;
    }

    acquire(tag: TagDefinitionVm, $event: angular.IAngularEvent) {
        this.selectedItem = tag;
        $event.preventDefault();
    }

    deleteTag($event: angular.IAngularEvent) {
        $('#deleteModal').modal('show');
    }

    duplicate(tag: TagDefinitionVm) {
        this.selectedItem = tag;
        $('#duplicateTag').modal('show');
    }

    private isSelected(item) {
        return this.selectedItem && item && item.guid === this.selectedItem.guid;
    }
}

export const wtTagsTiles: ComponentDefinition = {
    componentId: 'wtTagsTiles',
    controller: TagsTilesController,
    template: require('./tagsTiles.component.html'),
    controllerAs: 'vm',
    bindings: {
        tagViewModels: '<',
        selectedItem: '=',
        formController: '<',
        isEditMode: '<'
    }
};